<template>
  <div class="step-form-section">
    <div class="inner-container">
      <div class="input-group">
        <label for="age">
          {{ $t("labels.color") }}
        </label>
        <multiselect
          v-model="color"
          class="select-custom"
          :placeholder="$t('placeholders.selectFromList')"
          :options="colors"
          value-prop="Value"
          label="Text"
          :no-options-text="$t('placeholders.listEmpty')"
        >
          <template v-slot:caret>
            <span class="multiselect-caret-custom">
              <i class="far fa-chevron-down"></i>
            </span>
          </template>
        </multiselect>
      </div>
    </div>
    <div class="inner-container">
      <div class="input-group">
        <label for="age">
          {{ $t("labels.paintFinish") }}
        </label>
        <multiselect
          v-model="paintFinish"
          class="select-custom"
          :placeholder="$t('placeholders.selectFromList')"
          :options="paintFinishes"
          value-prop="Value"
          label="Text"
          :no-options-text="$t('placeholders.listEmpty')"
        >
          <template v-slot:caret>
            <span class="multiselect-caret-custom">
              <i class="far fa-chevron-down"></i>
            </span>
          </template>
        </multiselect>
      </div>
    </div>
    <div class="inner-container">
      <div class="input-group">
        <label for="age">
          {{ $t("labels.wheelSize") }}
        </label>
        <multiselect
          v-model="wheelSize"
          class="select-custom"
          :placeholder="$t('placeholders.selectFromList')"
          :options="wheelSizes"
          value-prop="Value"
          label="Text"
          :no-options-text="$t('placeholders.listEmpty')"
        >
          <template v-slot:caret>
            <span class="multiselect-caret-custom">
              <i class="far fa-chevron-down"></i>
            </span>
          </template>
        </multiselect>
      </div>
    </div>
    <div class="inner-container">
      <div class="input-group">
        <label for="age">
          {{ $t("labels.frameFabric") }}
        </label>
        <multiselect
          v-model="frameFabric"
          mode="multiple"
          :multiple-label="multipleSelectLabel"
          :close-on-select="false"
          :hide-selected="false"
          class="select-custom"
          :placeholder="$t('placeholders.selectFromList')"
          :options="frameFabrics"
          value-prop="Value"
          label="Text"
          :no-options-text="$t('placeholders.listEmpty')"
        >
          <template v-slot:caret>
            <span class="multiselect-caret-custom">
              <i class="far fa-chevron-down"></i>
            </span>
          </template>
        </multiselect>
      </div>
    </div>
    <div class="inner-container">
      <div class="input-group">
        <label for="age">
          {{ $t("labels.rearShockAbsorber") }}
        </label>
        <multiselect
          v-model="rearShockAbsorber"
          class="select-custom"
          :placeholder="$t('placeholders.select')"
          :options="['tak', 'nie']"
        >
          <template v-slot:caret>
            <span class="multiselect-caret-custom">
              <i class="far fa-chevron-down"></i>
            </span>
          </template>
        </multiselect>
      </div>
    </div>
    <div class="inner-container">
      <div class="input-group">
        <label for="age">
          {{ $t("labels.gearsNumber") }}
        </label>
        <multiselect
          v-model="gearsNumber"
          class="select-custom"
          :placeholder="$t('placeholders.selectFromList')"
          :options="gearsNumberSorted"
          value-prop="Value"
          label="Text"
          :no-options-text="$t('placeholders.listEmpty')"
        >
          <template v-slot:caret>
            <span class="multiselect-caret-custom">
              <i class="far fa-chevron-down"></i>
            </span>
          </template>
        </multiselect>
      </div>
    </div>
    <div class="inner-container">
      <div class="input-group">
        <label for="age">
          {{ $t("labels.electricBike") }}
        </label>
        <multiselect
          v-model="electricBike"
          class="select-custom"
          :options="['tak', 'nie']"
          :placeholder="$t('placeholders.select')"
        >
          <template v-slot:caret>
            <span class="multiselect-caret-custom">
              <i class="far fa-chevron-down"></i>
            </span>
          </template>
        </multiselect>
      </div>
    </div>
  </div>
</template>
<script>
// vuex
import { mapFields } from "vuex-map-fields";

// components
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";

// css
import "./StepForm.scss";

// methods
import updateUrlParams from "@/router/middleware/updateUrlParamsMiddleware";
import setCookie from "@/utils/setCookie";

// enums
import { genderEnum } from "@/enums/genderEnum";
export default {
  name: "AdvancedFilters",
  data() {
    return {
      genderEnum,
    };
  },
  computed: {
    ...mapFields([
      "filters.color",
      "filters.paintFinish",
      "filters.wheelSize",
      "filters.frameFabric",
      "filters.rearShockAbsorber",
      "filters.gearsNumber",
      "filters.electricBike",
      "colors",
      "wheelSizes",
      "frameFabrics",
      "gearsNumbers",
      "paintFinishes",
    ]),
      gearsNumberSorted: function () {
          let temp = this.gearsNumbers || [];
          temp.sort(function (a, b) {
              return parseFloat(a.Text) - parseFloat(b.Text);
          });
          return temp;
      }
  },
  watch: {
    // watch every filter value change and save it in cookies and URL parameters
    color: function (newVal) {
      setCookie("color", newVal, this);
      updateUrlParams();
    },
    paintFinish: function (newVal) {
      setCookie("paintFinish", newVal, this);
      updateUrlParams();
    },
    wheelSize: function (newVal) {
      setCookie("wheelSize", newVal, this);
      updateUrlParams();
    },
    frameFabric: function (newVal) {
      setCookie("frameFabric", newVal.join(), this);
      updateUrlParams();
    },
    rearShockAbsorber: function (newVal) {
      setCookie("rearShockAbsorber", newVal, this);
      updateUrlParams();
    },
    gearsNumber: function (newVal) {
      setCookie("gearsNumber", newVal, this);
      updateUrlParams();
    },
    electricBike: function (newVal) {
      setCookie("electricBike", newVal, this);
      updateUrlParams();
    },
  },
  methods: {
    multipleSelectLabel: function (e) {
      if (e.length) {
        if (e.length < 5) {
          return this.$t("labels.optionSelected", [e.length]);
        } else if (e.length >= 5) {
          return this.$t("labels.optionsSelected", [e.length]);
        } else {
          return "";
        }
      }
    },
    // used in mounted hook. Retrieves filters values from browser cookies
    getCookies() {
      const frameFabric = this.$cookies.get("frameFabric");
      if (frameFabric) {
        let cookieFrameFabric = frameFabric.split(",");
        if (cookieFrameFabric) {
          this.frameFabric = cookieFrameFabric;
        }
      }

      const color = this.$cookies.get("color");
      if (color) this.color = color;

      const paintFinish = this.$cookies.get("paintFinish");
      if (paintFinish) this.paintFinish = paintFinish;

      const wheelSize = this.$cookies.get("wheelSize");
      if (wheelSize) this.wheelSize = wheelSize;

      const rearShockAbsorber = this.$cookies.get("rearShockAbsorber");
      if (rearShockAbsorber) this.rearShockAbsorber = rearShockAbsorber;

      const gearsNumber = this.$cookies.get("gearsNumber");
      if (gearsNumber) this.gearsNumber = gearsNumber;

      const electricBike = this.$cookies.get("electricBike");
      if (electricBike) this.electricBike = electricBike;
    },
  },
  mounted() {
    // set filters values depending on cookies
    this.getCookies();
  },
  components: {
    Multiselect,
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
